import Home from "../pages/home";
import MarketingPage from "../pages/marketing";

export const InicioRoute = () => <Home></Home>
export const MarketingRoute = () => <MarketingPage></MarketingPage>